import { PropsWithChildren, createContext, useContext, useMemo } from 'react';
import { MenuTriggerState } from 'react-stately';

type MobileSiteHeaderContextValue = {
  state: MenuTriggerState;
};

const MobileSiteHeaderContext = createContext<MobileSiteHeaderContextValue>({
  state: null as unknown as MenuTriggerState,
});

type MobileSiteHeaderProviderProps = {
  state: MenuTriggerState;
};

export function MobileSiteHeaderProvider({
  children,
  state,
}: PropsWithChildren<MobileSiteHeaderProviderProps>) {
  const contextValue = useMemo(
    () => ({
      state,
    }),
    [state],
  );

  return (
    <MobileSiteHeaderContext.Provider value={contextValue}>
      {children}
    </MobileSiteHeaderContext.Provider>
  );
}

export function useMobileSiteHeader() {
  return useContext(MobileSiteHeaderContext);
}
